<template>
  <svg
    class="p-icon-header-favorite"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 36 36"
    fill="none"
    aria-hidden="true"
  >
    <g transform="translate(7.23505 8.5761)">
      <path
        class="p-icon-header-favorite__shape"
        d="M19.4021 2.77823C18.4585 1.61694 17.0795 1 15.4192 1C12.6884 1 11.3728 3.26815 10.765 4.41129C10.148 3.26815 8.84158 1 6.11074 1C4.45045 1 3.07142 1.61694 2.12787 2.77823C0.730693 4.50202 0.821419 7.42339 1.38392 8.90222C2.69944 12.3407 9.57646 17.1583 10.4746 17.7571C10.5654 17.8115 10.6652 17.8478 10.765 17.8478C10.8648 17.8478 10.9646 17.8206 11.0553 17.7571C11.9535 17.1583 18.8396 12.3407 20.146 8.90222C20.7085 7.42339 20.7993 4.50202 19.4021 2.77823Z"
        stroke="currentColor"
        stroke-width="2"
        stroke-linejoin="round"
      />
    </g>
  </svg>
</template>

<style lang="scss" scoped>
.p-icon-header-favorite__shape {
  transition: fill $transition-sec--fast ease-in,
    stroke $transition-sec--fast ease-in;
}
</style>
